import { CloseOutlined } from '@ant-design/icons';
import { useAuth } from '@context/AuthContext';
import {
  useGetExpiringPromotionsBannerLazyQuery,
  useMarkPopupBannerAsShownMutation,
  useShowPopupBannerForExpiringPromotionsSubscription,
} from '@hooks/banner';
import { fireClickPromotionPopupEvent, fireClosePromotionPopupEvent } from '@utils/gtmUtils';
import { Modal } from 'antd';
import dayjs from 'dayjs';
import Image from 'next/image';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';

import popupBannerBg from '../../public/images/banner-bg.png';

import s from './index.module.less';
import { getCompanyBasedRoute } from '@utils/routeConstants';
import { useTranslation } from 'next-i18next';

const PopupBanner = () => {
  const { t: tLayout } = useTranslation('layout');
  const router = useRouter();
  const [isPopupVisible, setPopupVisible] = useState<boolean>(false);

  const [markPopupBannerAsShown] = useMarkPopupBannerAsShownMutation();

  const showPopAndMarkAsShown = (popupBannerId: string) => {
    setPopupVisible(true);
    markPopupBannerAsShown({
      variables: {
        input: {
          popupBannerId,
        },
      },
    });
  };

  // Use when the user is online at the time the trigger happens
  const { isLoggedIn } = useAuth();
  useShowPopupBannerForExpiringPromotionsSubscription({
    onSubscriptionData: ({ subscriptionData }) => {
      const popupBannerId = subscriptionData.data?.showPopupBannerForExpiringPromotions?.popupBannerId;
      if (!popupBannerId) return;
      showPopAndMarkAsShown(popupBannerId);
    },
    skip: !isLoggedIn,
  });

  // Use when the user is offline at the time the trigger happens
  //  and the banner is not shown yet
  const [fetchExpiringPromotionsBanner] = useGetExpiringPromotionsBannerLazyQuery({
    onCompleted: data => {
      const popupBannerId = data.expiringPromotionsBanner;
      if (!popupBannerId) return;
      showPopAndMarkAsShown(popupBannerId);
    },
  });
  useEffect(() => {
    if (isLoggedIn) {
      fetchExpiringPromotionsBanner();
    }
  }, [isLoggedIn]);

  const modalConfig = {
    visible: isPopupVisible,
    centered: true,
    closable: true,
    closeIcon: ' ',
    mask: true,
    maskClosable: true,
    width: 700,
    title: null,
    footer: null,
    onCancel: () => {
      fireClosePromotionPopupEvent();
      setPopupVisible(false);
    },
    bodyStyle: { padding: '0' },
  };
  const now = dayjs().format('MM/YYYY');

  return (
    <Modal {...modalConfig} data-testid="popup-banner">
      <div
        className={s.bannerContainer}
        onClick={() => {
          setPopupVisible(false);
          fireClickPromotionPopupEvent();
          router.push(getCompanyBasedRoute(`account/campaign`));
        }}
      >
        <div>
          <button className={s.closeButton}>
            <CloseOutlined />
          </button>
        </div>
        <div className={s.content}>
          <p className={s.title}>{tLayout('promotion')}</p>
          <p className={s.time}>
            {tLayout('month')} {now}
          </p>
          <button className={s.secondButton}>{tLayout('buy_now')}</button>
          <p className={s.alert}>{tLayout('let_check_promotion_month', { now })}</p>
        </div>
        <Image src={popupBannerBg} objectFit="fill" style={{ cursor: 'pointer', zIndex: 1 }} />
      </div>
    </Modal>
  );
};

export default PopupBanner;
